export const toastsSliceName = 'toasts';
